import Swiper from '../libs/swiper.min';
function swiper() {
  personIntroSlider();
  blockquotesSlider();
  candidateSlider();
}
function personIntroSlider() {
  var $swiperContainer = jQuery('.js-swiper-intro-slider');
  if (!jQuery('.js-swiper-intro-slider').length) return;
  var swiper = new Swiper($swiperContainer, {
    speed: 700,
    direction: 'vertical',
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 3200,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  });
  var slidesCount = swiper.slides.filter(function (i, slide) {
    return slide && !jQuery(slide).hasClass('swiper-slide-duplicate');
  }).length;
  var randomSlide = Math.floor(Math.random() * slidesCount);
  swiper.slideTo(randomSlide, 0);
}
function blockquotesSlider() {
  var $swiperContainer = jQuery('.js-swiper-blockquotes');
  var swiper = new Swiper($swiperContainer, {
    speed: 400,
    loop: true,
    spaceBetween: 40,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}
function candidateSlider() {
  if (!jQuery('.candidate-slider__container').length) return;
  var $swiperContainer = jQuery('.candidate-slider__container');
  var swiper = new Swiper($swiperContainer, {
    speed: 700,
    loop: false,
    direction: 'horizontal',
    centeredSlides: true,
    spaceBetween: 12,
    // autoplay: {
    //   delay: 3200,
    //   disableOnInteraction: false,
    // },
    wrapperClass: 'candidate-slider',
    slideClass: 'candidate-card',
    navigation: {
      nextEl: '.candidate-slider__navigation-next',
      prevEl: '.candidate-slider__navigation-prev'
    },
    slidesPerView: 'auto',
    updateOnWindowResize: true,
    breakpoints: {
      768: {
        centeredSlides: false
      }
    }
  });
}
function analiticSlider() {
  var $swiperContainer = jQuery('.js-analitic-swiper');
  var analiticSwiper = new Swiper($swiperContainer, {
    centeredSlides: true,
    speed: 400,
    spaceBetween: 40,
    slidesPerView: 1,
    direction: 'horizontal',
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.btn-swiper-next',
      prevEl: '.btn-swiper-prev'
    }
  });
}
function employeesSlider() {
  var $swiperContainer = jQuery('.js-employees-slider');
  var employeesSlider = new Swiper($swiperContainer, {
    speed: 400,
    spaceBetween: 40,
    slidesPerView: 1,
    direction: 'horizontal',
    loop: true,
    navigation: {
      nextEl: '.btn-swiper-next',
      prevEl: '.btn-swiper-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}
function partnersSlider() {
  var $swiperContainer = jQuery('.js-partners-slider');
  var partnersSlider = new Swiper($swiperContainer, {
    speed: 400,
    spaceBetween: 20,
    slidesPerView: 2,
    direction: 'horizontal',
    breakpoints: {
      480: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 60
      }
    },
    navigation: {
      nextEl: '.btn-swiper-next',
      prevEl: '.btn-swiper-prev'
    }
  });
}
function newsSlider() {
  var $swiperContainer = jQuery('.swiper-container');
  var newsSlider = new Swiper($swiperContainer, {
    centeredSlides: true,
    speed: 400,
    spaceBetween: 40,
    slidesPerView: 1,
    direction: 'horizontal',
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  });
}
function solutionSlider() {
  var sliderContainer = '.swiper-solutions, .swiper-deals';
  var breakpoint = 1023;
  var slider;
  var sliderWrapper = '.swiper-wrapper';
  var sliderSlides = '.swiper-slide';
  function initSwiper() {
    var screenWidth = $(window).width();
    if (screenWidth <= breakpoint && slider == undefined) {
      var menu = getMenu();
      slider = new Swiper(sliderContainer, {
        centeredSlides: true,
        speed: 400,
        spaceBetween: 10,
        slidesPerView: 1,
        direction: 'horizontal',
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination-top, .swiper-pagination-bottom',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return "<li class=\"swiper-anchor__item ".concat(className, "\">\n                    <a href=\"#\" class=\"swiper-anchor__link\">\n                        <span class=\"swiper-anchor__text\">").concat(menu[index], "</span>\n                    </a>\n                </li>");
          }
        }
      });
      removeContentInBottomMenu();
    } else if (screenWidth >= breakpoint && slider != undefined) {
      slider.destroy();
      slider = undefined;
      jQuery(sliderWrapper).removeAttr('style');
      jQuery(sliderSlides).removeAttr('style');
    }
  }
  if (jQuery(sliderContainer).length > 0) {
    initSwiper();
  }
  function descroyAll(array) {
    array.forEach(function (item, i) {
      item.destroy();
    });
  }
  function removeContentInBottomMenu() {
    var bottomAnchors = jQuery('.swiper-pagination-bottom').find('.swiper-anchor__item');
    bottomAnchors.each(function (i, item) {
      jQuery(item).children().remove();
    });
  }
  function getMenu() {
    var menuTitle = jQuery(sliderContainer).find('h3');
    return menuTitle.map(function (i, item) {
      return item.innerText;
    });
  }
  jQuery(window).on('resize', function () {
    if (jQuery(sliderContainer).length > 0) {
      initSwiper();
    }
  });
}
export default swiper;